var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_SUM_REQUEST'
      )
    }},[_c('vue-numeric',{staticClass:"i-main-style i-wid-13",attrs:{"disabled":_vm.$parent.$parent.projectDisabled ||
          _vm.$parent.project.IS_BLOCK_SUM_ZAIM == 1,"currency":"","separator":"space","type":"text"},on:{"change":_vm.updateSummRequest},model:{value:(_vm.sumRequest),callback:function ($$v) {_vm.sumRequest=$$v},expression:"sumRequest"}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_SUM_REQUEST"))+"\n    ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }